// FOFUS site detection (02 Oct) — one host map for all surfaces.
// The single Vite app serves designai.fofus.in (AI generator), designers
// .fofus.in (designer marketplace) and now account.fofus.in (FOFUS Account).
export const isDesignersSite =
  typeof window !== "undefined" && window.location.hostname.startsWith("designers.");

export const isAccountSite =
  typeof window !== "undefined" && window.location.hostname.startsWith("account.");

// The customer account home. On other hosts this jumps to account.fofus.in
// (full document load — foid_session rides along on .fofus.in).
export const ACCOUNT_BASE = "https://account.fofus.in";

export const isDesignAiSite =
  typeof window !== "undefined" &&
  !isDesignersSite &&
  !window.location.hostname.startsWith("account.");